import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import Indentation from '../../../../components/Simple/Indentation';
import SMCNumberInput from '../../../../components/Simple/SMCNumberInput';
import {SystemSettingsGetSchema} from '../../../../api/DBSchema/SystemSettings';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import SMCPasswordInput from '../../../../components/Simple/SMCPasswordInput';

const pageSchema = SystemSettingsGetSchema.pages.httpProxy;
const pageId = pageSchema.pageId;

function SystemSettingsHttpProxy({
    systemSettingsObject,
    setSystemSettingsData
}) {
    const { t } = useTranslation();

    const pageData = systemSettingsObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setSystemSettingsData([pageId, paramName], value);
    }, [setSystemSettingsData]);

    const isProxy   = pageData[pageSchema.isProxy];
    const proxyHost = pageData[pageSchema.proxyHost];
    const proxyPort = pageData[pageSchema.proxyPort];
    const proxyUser = pageData[pageSchema.proxyUser];
    const proxyPass = pageData[pageSchema.proxyPass];

    return (
        <EditorLayout>
            <SMCCheckbox
                label={t('SMP.SETTINGS.HTTP_PROXY')}
                tooltip={t('SMP.SETTINGS.HTTP_PROXY.TOOLTIP')}
                checked={isProxy}
                onChange={e => setPageValue(pageSchema.isProxy, e.target.checked)}
            />
            {
                isProxy && (
                    <Indentation>
                        <SMCTextInput
                            value={proxyHost}
                            onChange={e => setPageValue(pageSchema.proxyHost, e.target.value)}
                            label={t('SMP.SETTINGS.HTTP_PROXY.PROXY')}
                        />
                        <SMCNumberInput
                            value={proxyPort}
                            onChange={e => setPageValue(pageSchema.proxyPort, parseInt(e.target.value))}
                            label={t('SMP.SETTINGS.HTTP_PROXY.PORT')}
                        />
                        <SMCTextInput
                            value={proxyUser}
                            onChange={e => setPageValue(pageSchema.proxyUser, e.target.value)}
                            label={t('SMP.SETTINGS.HTTP_PROXY.USER')}
                        />
                        <SMCPasswordInput
                            value={proxyPass}
                            onChange={e => setPageValue(pageSchema.proxyPass, e.target.value)}
                            label={t('SMP.SETTINGS.HTTP_PROXY.PWD')}
                            allowPasswordPeek={true}
                        />
                    </Indentation>
                )
            }
            <SMCLabel><b>{t('SMP.SETTINGS.HTTP_PROXY.NOTE')}:</b>{t('SMP.SETTINGS.HTTP_PROXY.NOTE1')}</SMCLabel>
        </EditorLayout>
    )
}

export default SystemSettingsHttpProxy;